<template>
  <div class="page-contact" v-loading.fullscreen="loading">

    <div v-for="(block, index) in blocks" :key="`block-${index}`">
      <info-block :data="block"></info-block>
    </div>

    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">

          <div class="is-gap-xlarge is-gap-bottom">
            <formm
              ref="form"
              :form="form"
              :rules="formRules"
              :columns="formColumns"
              :data="formData">
            </formm>
          </div>

          <div class="is-gap-xlarge is-gap-top" style="margin-top:0;">
            <el-button type="primary" class="button color-green-bg" @click="onSubmit">
              Submit Inquiry
            </el-button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import Constants from '@/constants'
import ContactFormConstants from '@/pages/contact/formconstants'
import Util from '@/util'
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/site'

import InfoBlock from '@/pages/base/infoblock'
import Formm from '@/base/form'

export default {
  name: 'page-contact',
  props: {
    // msg: String
  },
  components: {
    InfoBlock,
    Formm,
  },
  data () {
    return {
      loading: false,
      isDesktop: true,
      blocks: [],
      // form
      form: {},
      formRules: {},
      // formColumns: ContactFormConstants.Form.COLUMNS,
      formData: {
        dataSelectYesNo: Constants.OPTIONS_YES_NO,
      },
    }
  },
  computed: {
    Util: function () {
      return Util
    },

    formColumns: function () {
      let columns = ContactFormConstants.Form.COLUMNS
      columns = Util.array.copy(columns)
      let cbIndex = _.findIndex(columns, (item) => item.name === 'checkboxes')
      if (cbIndex < 0) return columns
      let checkboxes = ContactFormConstants.Form.KEYS_CHECKBOX
      checkboxes = Util.array.copy(checkboxes)
      checkboxes = _.map(checkboxes, (cb) => {
        cb.name = cb.key
        cb.type = 'checkbox'
        cb.noGap = true
        cb.label = cb.key
        cb.class = 'is-4'
        return cb
      })
      columns.splice(cbIndex, 1, ...checkboxes)
      return columns
    }
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.clear()
    this.load()
    await this.refresh()
  },
  methods: {
    clear () {
      let keyinfos = ContactFormConstants.Form.KEYS
      let form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'form', form)

      form = this.form
      let ckeyinfos = ContactFormConstants.Form.KEYS_CHECKBOX
      for (let ck in ckeyinfos) {
        let ckeyinfo = ckeyinfos[ck]
        let ckey = ckeyinfo.key
        this.$set(this.form, ckey, false)
      }
    },

    load () {
      // this.$set(this.form, '')
    },

    async refresh () {
      try {
        this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getBlocks()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getBlocks () {
      this.$set(this, 'blocks', [])
      let data = await Site.infoNamedLike('page-contact')
      this.$set(this, 'blocks', data)
    },

    parseCheckboxes () {
      let keyinfos = ContactFormConstants.Form.KEYS_CHECKBOX
      let checkboxes = []
      for (let k in keyinfos) {
        let keyinfo = keyinfos[k]
        let key = keyinfo.key
        let form = this.form
        if (!form.hasOwnProperty(key)) continue
        switch (form[key]) {
          case true:
          case 1:
            checkboxes.push(key)
            break
          default:
            break
        }
      }
      return checkboxes
    },

    async onSubmit () {
      try {
        this.$set(this, 'loading', true)
        await this.$refs.form.validate()

        // form
        let form = _.assign({}, this.form)
        let keyinfos = ContactFormConstants.Form.KEYS
        form = Util.request.parseForm(keyinfos, form)

        // checkboxes
        let cbs = this.parseCheckboxes() || []
        form.note = cbs.join(', ')

        console.log('-- submit.form', form)
        let response = await Site.emailSubmit(form)
        console.log('-- submit.response', response)

        this.clear()
        this.$alert('Email sent successfully.', {
          type: 'success'
        })

        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        if (error === false) return
        this.$message({
          message: `Submit failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },
  }
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../styles/app_setting.scss";

.page-contact {
}

</style>
